@if (icon) {
    <span class="app-icon">
        @for (i of map[icon]; track i) {
            <fa-icon [icon]="i"></fa-icon>
        }
        @if (label) {
            <span class="label">{{ label }}</span>
        }
    </span>
}
